import * as React from 'react';
import { useState } from 'react';
import { InboxIcon, PlusIcon } from '@heroicons/react/20/solid';

import { useTrack } from '@blockworks/platform/services/analytics';

import PrimaryButton from '@/components/display/buttons/primary-button';
import SecondaryButton from '@/components/display/buttons/secondary-button';
import { BreadCrumbItem } from '@/components/display/headers/breadcrumb';
import PageHeader from '@/components/display/headers/page-header';
import GrantsTabs from '@/components/display/tabs/tabs';
import GrantsPopupDialog, { DialogData } from '@/components/pages/grants/components/grants-popup-dialog';

type Props = {
    breadcrumb: BreadCrumbItem[];
    title?: string;
    description?: string;
    counts?: number[];
    hideTabs?: boolean;
};

const GrantsHeader = (props: Props) => {
    // <Breadcrumb items={props.breadcrumb} />
    const [isOpen, setIsOpen] = useState(false);
    const [dialogData, setDialogData] = useState<DialogData | null>(null);
    const track = useTrack();

    return (
        <div>
            <div className="mb-4 xxs:mb-0 xxs:float-right flex flex-wrap xs:flex-nowrap flex-row gap-2">
                <SecondaryButton
                    onClick={() => {
                        setDialogData({
                            title: 'Provide Feedback',
                            iframeUrl: 'https://e8mj4luoylz.typeform.com/to/hRnp7ldi',
                            project: '',
                            isOpen,
                        });
                        setIsOpen(true);
                        track('Grants.ClickedProvideFeedback');
                    }}
                    size="small"
                >
                    <InboxIcon className="-ml-0.5 md:mr-1 h-4 w-4" aria-hidden="true" />
                    <span className="hidden md:inline-block md:mr-1">Provide</span>
                    <span className="hidden md:inline-block">Feedback</span>
                </SecondaryButton>
                <PrimaryButton
                    onClick={() => {
                        setDialogData({
                            title: 'Submit Grant',
                            iframeUrl: 'https://e8mj4luoylz.typeform.com/to/Q66ZaZkW',
                            project: '',
                            isOpen,
                        });
                        setIsOpen(true);
                        track('Grants.ClickedSubmitGrant');
                    }}
                    size="small"
                >
                    <PlusIcon className="-ml-0.5 md:mr-1 h-4 w-4" aria-hidden="true" />
                    <span className="hidden md:inline-block">Submit Grant</span>
                </PrimaryButton>
            </div>
            {props.hideTabs ? null : (
                <GrantsTabs
                    tabs={[
                        { name: 'Individual Grants', href: '/grants', current: true, count: props.counts?.[0] ?? 0 },
                        {
                            name: 'Grant Programs',
                            href: '/grants/programs',
                            current: false,
                            count: props.counts?.[1] ?? 0,
                        },
                    ]}
                />
            )}
            <PageHeader
                title={props.title || ''}
                description={
                    props.description ||
                    'Protocols and projects launch grant programs to reward teams and individuals to build in their ecosystem. Blockworks has compiled the largest real-time directory list of all grants, RFPs, and bug bounties.'
                }
                className="mt-5"
                h1ClassName="font-semibold text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl text-left text-gray-900"
            />
            {dialogData?.title && dialogData?.iframeUrl && (
                <GrantsPopupDialog
                    title={dialogData!.title}
                    url={dialogData!.iframeUrl}
                    isOpen={isOpen}
                    onClose={() => setIsOpen(false)}
                    height={500}
                    width={780}
                />
            )}
        </div>
    );
};

export default GrantsHeader;
